/**
 * **The features, named once** — every screen that names a feature (Setup's
 * switches, the Activity sentences, the partner-key dialog) reads these
 * through `ui/business/features.ts`, so "Gift cards" on a switch is "gift
 * cards" in "Jose turned on gift cards" and never "gift certificates"
 * somewhere else.
 *
 * Two forms each: the **title** a switch or a heading carries, and the form a
 * **sentence** wants in its middle — lower case, and in Spanish with its
 * article ("activó las tarjetas de regalo").
 */
export const featuresEn = {
  'feature.calendar': 'Calendar',
  'feature.calendar.said': 'the calendar',
  'feature.clients': 'Client book',
  'feature.clients.said': 'the client book',
  'feature.services': 'Service menu',
  'feature.services.said': 'the service menu',
  'feature.sales': 'Checkout',
  'feature.sales.said': 'checkout',
  'feature.products': 'Boutique',
  'feature.products.said': 'the boutique',
  'feature.certificates': 'Gift cards',
  'feature.certificates.said': 'gift cards',
  'feature.credit': 'Account credit',
  'feature.credit.said': 'account credit',
  'feature.reporting': 'Reports',
  'feature.reporting.said': 'reports',
  'feature.billing': 'Online payments',
  'feature.billing.said': 'online payments',
  'feature.booking_site': 'Website',
  'feature.booking_site.said': 'the website',
  'feature.notifications': 'Texts and emails',
  'feature.notifications.said': 'texts and emails',
  'feature.partner_api': 'Booking partners',
  'feature.partner_api.said': 'booking partners',
  'feature.ordering': 'Restaurant ordering',
  'feature.ordering.said': 'restaurant ordering',
  'feature.lodging': 'Rooms and stays',
  'feature.lodging.said': 'rooms and stays',
  'feature.departures': 'Tours and sailings',
  'feature.departures.said': 'tours and sailings',
  'feature.photos': 'Tour photos',
  'feature.photos.said': 'tour photos',
  'feature.fulfillment': 'Merch and prints',
  'feature.fulfillment.said': 'merch and prints',
  'feature.admin': 'Operator access',
  'feature.admin.said': 'operator access',
};

export const featuresEs: typeof featuresEn = {
  'feature.calendar': 'Agenda',
  'feature.calendar.said': 'la agenda',
  'feature.clients': 'Libreta de clientes',
  'feature.clients.said': 'la libreta de clientes',
  'feature.services': 'Menú de servicios',
  'feature.services.said': 'el menú de servicios',
  'feature.sales': 'Cobro',
  'feature.sales.said': 'el cobro',
  'feature.products': 'Tienda',
  'feature.products.said': 'la tienda',
  'feature.certificates': 'Tarjetas de regalo',
  'feature.certificates.said': 'las tarjetas de regalo',
  'feature.credit': 'Saldo a favor',
  'feature.credit.said': 'el saldo a favor',
  'feature.reporting': 'Informes',
  'feature.reporting.said': 'los informes',
  'feature.billing': 'Pagos en línea',
  'feature.billing.said': 'los pagos en línea',
  'feature.booking_site': 'Sitio web',
  'feature.booking_site.said': 'el sitio web',
  'feature.notifications': 'Mensajes y correos',
  'feature.notifications.said': 'los mensajes y correos',
  'feature.partner_api': 'Socios de reservas',
  'feature.partner_api.said': 'los socios de reservas',
  'feature.ordering': 'Pedidos de restaurante',
  'feature.ordering.said': 'los pedidos de restaurante',
  'feature.lodging': 'Habitaciones y estancias',
  'feature.lodging.said': 'las habitaciones y estancias',
  'feature.departures': 'Excursiones y salidas',
  'feature.departures.said': 'las excursiones y salidas',
  'feature.photos': 'Fotos de excursiones',
  'feature.photos.said': 'las fotos de excursiones',
  'feature.fulfillment': 'Artículos e impresiones',
  'feature.fulfillment.said': 'los artículos e impresiones',
  'feature.admin': 'Acceso del operador',
  'feature.admin.said': 'el acceso del operador',
};
